module.exports = __webpack_public_path__ + "img/preventative-dental-care.25c1fb31.jpg";